import {isMobile} from "../modules/general";

document.addEventListener('DOMContentLoaded', () => {
    const CONFIG = {
        selectors: {
            mobAppContainer: '.mobile-application',
            appRow: '.mobile-application__row',
            androidStore: '.mobile-application__store--android',
            iosStore: '.mobile-application__store--ios',
            ruStore: '.mobile-application__store--rustore',
            googlePlayLink: '.mobile-application__store--android .mobile-application__store-link',
            appStoreLink: '.mobile-application__store--ios .mobile-application__store-link',
            ruStoreLink: '.mobile-application__store--rustore .mobile-application__store-link'
        },
        modifiers: {
            shownLink: 'mobile-application__store-link--shown',
            oneStore: 'mobile-application__row--one-store',
            linksWrapper: 'mobile-application__mobile-links-wrapper',
            mobAppContainerTwoLinks: 'mobile-application--two-links',
        },
        breakpoints: {
            mobile: 767
        }
    };

    const mobAppContainer = document.querySelector(CONFIG.selectors.mobAppContainer);
    if (!mobAppContainer) return;

    const appRow = mobAppContainer.querySelector(CONFIG.selectors.appRow);
    const androidStore = mobAppContainer.querySelector(CONFIG.selectors.androidStore);
    const iosStore = mobAppContainer.querySelector(CONFIG.selectors.iosStore);
    const ruStore = mobAppContainer.querySelector(CONFIG.selectors.ruStore);
    const googlePlayLink = mobAppContainer.querySelector(CONFIG.selectors.googlePlayLink);
    const appStoreLink = mobAppContainer.querySelector(CONFIG.selectors.appStoreLink);
    const ruStoreLink = mobAppContainer?.querySelector(CONFIG.selectors.ruStoreLink);

    const isAppleDevice = isMobile.iOS();
    const isAndroidDevice = isMobile.Android();
    const isMobileOrTablet = isMobile.any();
    const isDevMode = window.location.href.indexOf("dev_mode_app") !== -1;

    if (androidStore) androidStore.style.display = '';
    if (iosStore) iosStore.style.display = '';
    if (ruStore && isDevMode) ruStore.style.display = '';
    if (appRow) appRow.classList.remove(CONFIG.modifiers.oneStore);

    if (isDevMode) {
        const isMobilePhone = window.innerWidth <= CONFIG.breakpoints.mobile;
        if (isMobilePhone) {
            if (isAppleDevice) {
                if (androidStore) androidStore.style.display = 'none';
                if (ruStore) ruStore.style.display = 'none';
                if (appRow) appRow.classList.add(CONFIG.modifiers.oneStore);
            } else if (isAndroidDevice) {
                if (iosStore) iosStore.style.display = 'none';
                if (appRow) appRow.classList.add(CONFIG.modifiers.oneStore);
            }
        }
    } else {
        if (isMobileOrTablet) {
            if (isAppleDevice) {
                if (androidStore) androidStore.style.display = 'none';
                if (appRow) appRow.classList.add(CONFIG.modifiers.oneStore);
            } else if (isAndroidDevice) {
                if (iosStore) iosStore.style.display = 'none';
                if (appRow) appRow.classList.add(CONFIG.modifiers.oneStore);
            }
        }
    }

    const renderMobileStoreLink = () => {
        if (window.innerWidth > CONFIG.breakpoints.mobile) {
            return;
        }

        if (isMobileOrTablet) {
            if (isAppleDevice) {
                if (appStoreLink) {
                    appStoreLink.classList.add(CONFIG.modifiers.shownLink);
                    mobAppContainer.appendChild(appStoreLink);
                }
            } else if (isAndroidDevice) {
                if (isDevMode) {
                    const wrapper = document.createElement('div');
                    wrapper.classList.add(CONFIG.modifiers.linksWrapper);

                    if (googlePlayLink) {
                        googlePlayLink.classList.add(CONFIG.modifiers.shownLink);
                        wrapper.appendChild(googlePlayLink);
                    }

                    if (ruStoreLink) {
                        ruStoreLink.classList.add(CONFIG.modifiers.shownLink);
                        wrapper.appendChild(ruStoreLink);
                    }

                    if (wrapper.children.length === 2) {
                        mobAppContainer.classList.add(CONFIG.modifiers.mobAppContainerTwoLinks);
                    }

                    if (wrapper.children.length > 0) {
                        mobAppContainer.appendChild(wrapper);
                    }
                } else {
                    if (googlePlayLink) {
                        googlePlayLink.classList.add(CONFIG.modifiers.shownLink);
                        mobAppContainer.appendChild(googlePlayLink);
                    }
                }
            }
        }
    };

    renderMobileStoreLink();
});